import axios from "../../api/axios"

export default function interceptor(accessToken) {
  axios.interceptors.request.use((request) => {
    request.headers["Authorization"] = `Bearer ${accessToken}`;
    return request;
  });
}
